import script from "./StudentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDetails.vue?vue&type=script&setup=true&lang=js"

import "./StudentDetails.vue?vue&type=style&index=0&id=6b54027a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b54027a"]])

export default __exports__